import { useQuery } from "@pinia/colada";

import { apiGetWidgetData } from "@/shared/api";
import { useWidgetContext } from "@/shared/config";

import { useGlobalStore } from "./useGlobalStore";

/** Данные виджета партнёра. Загружаются только после старта trade-in */
export function useApiGetWidgetData() {
    const { settings } = useWidgetContext();
    const globalStore = useGlobalStore();

    return useQuery(() => ({
        key: ["widget-data", settings.domain],
        query: () => apiGetWidgetData({ domain: settings.domain }),
        enabled: globalStore.isStarted,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    }));
}
